module.exports = __webpack_public_path__ + "static/img/A6405.69fb0e60.png";